import { PageName, UserInfo, UserPermissions } from "./types";

const pageTitles = {
  [PageName.home.valueOf()]:               {adminTitle: "AppTap",                     externalTitle: "AppTap"},
  [PageName.overall.valueOf()]:            {adminTitle: "📊 Overall (Reporting)",     externalTitle:"AppTap - Reporting - Overall"},
  [PageName.products.valueOf()]:           {adminTitle: "📊 Products (Reporting)",    externalTitle:"AppTap - Reporting - Products"},
  [PageName.performanceReports.valueOf()]: {adminTitle: "📊 Performance (Reporting)", externalTitle:"AppTap - Reporting - Performance"},
  [PageName.campaignLinks.valueOf()]:      {adminTitle: "🔗 cLinks (Campaigns)",      externalTitle: "AppTap - Campaigns"},
  [PageName.campaignLookup.valueOf()]:     {adminTitle: "🔍 cLookup (Campaigns)",     externalTitle: "AppTap - Campaigns"},
}

export function setDocumentTitle(page:string, currentUser:UserInfo) {
  if ( !currentUser ) {
    document.title = process.env.REACT_APP_NAME;
  }
  page = page ? page : PageName.overall.valueOf();

  let title;
  let admin = currentUser.permissions.includes(UserPermissions.appptapDataFullAccess);

  if (admin) {
    title = pageTitles[page] ? pageTitles[page].adminTitle : process.env.REACT_APP_NAME;
  }
  else {
    title = pageTitles[page] ? pageTitles[page].externalTitle : process.env.REACT_APP_NAME;
  }

  if (process.env.REACT_APP_BRANCH && process.env.REACT_APP_BRANCH.length) {
    title = `${process.env.REACT_APP_BRANCH} - ${title}`;
  }

  document.title = title;
}
